import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { Button } from "@mui/material";
import { useCreateOpenBankingConnection } from "./useCreateOpenBankingConnection";
import CheckIcon from "@mui/icons-material/Check";
import { LoadingButton } from "@mui/lab";
import { TestPersonaPickerDialog } from "../CreditCheck/TestPersonaPickerDialog";
import { useState } from "react";

const isTestEnvironment =
  process.env.NX_FIREBASE_PROJECT_ID !== "salt-finance-prod-fb791";

export const CreateOpenBankingConnection = ({
  sailorId,
  openBankingStatus,
  disabled,
}) => {
  const { run, loading } = useCreateOpenBankingConnection();
  const [personaPickerOpen, setPersonaPickerOpen] = useState(false);

  if ("Success" === openBankingStatus) {
    return (
      <Button
        size="small"
        variant="contained"
        endIcon={<CheckIcon />}
        disabled={true}
        color="success"
      >
        Open Banking Connected
      </Button>
    );
  }

  const handleClick = () => {
    if (isTestEnvironment) {
      setPersonaPickerOpen(true);
    } else {
      run(sailorId);
    }
  };

  const handlePersonaSelect = (personaName) => {
    setPersonaPickerOpen(false);
    run(sailorId, personaName);
  };

  return (
    <>
      <LoadingButton
        size="small"
        variant="contained"
        color="primary"
        loadingPosition="start"
        startIcon={<PersonSearchIcon />}
        disabled={disabled}
        loading={loading}
        onClick={handleClick}
      >
        Create New Connection
      </LoadingButton>
      {isTestEnvironment && (
        <TestPersonaPickerDialog
          open={personaPickerOpen}
          onClose={() => setPersonaPickerOpen(false)}
          onSelect={handlePersonaSelect}
        />
      )}
    </>
  );
};
